import React, { useEffect, useState } from "react";
import { MyListOrder } from "../../components/myListOrder/myListOrder";
import { useRequest } from "../../utils";
import styles from "./OrdersPanel.module.css";

/**
 * Ordinary orders list — visual alignment with GetQuotes.
 * Preserves POST /get_orders filters, pagination, and detail links.
 * (Isolated workspace copy — not deployed.)
 */
const GetOrders = () => {
  const [page, setPage] = useState(1);
  const [search_text, set_search_text] = useState("");
  const [_status, set_status] = useState(null);
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });
  const [start_date, set_start_date] = useState();
  const [end_date, set_end_date] = useState();

  const [
    GetPayments_error,
    GetPayments_loading,
    GetPayments_data,
    GetPayments_function,
  ] = useRequest({
    method: "post",
    url: "/get_orders",
    body: {
      page,
      search_text,
      _status,
      start_date,
      end_date,
    },
  });

  useEffect(() => {
    GetPayments_function().then(() => null);
  }, [page]);

  return (
    <div className={styles.root}>
      <div className={styles.pageHead}>
        <div className={styles.titleBlock}>
          <h1>سفارشات</h1>
          <p className={styles.subtitle}>
            سفارش‌های فروشگاه · جستجو با شماره فاکتور · فیلتر وضعیت پرداخت و بازه
            تاریخ
          </p>
        </div>
        <div className={styles.toolbar}>
          <button
            type="button"
            className={styles.btnGhost}
            onClick={() => {
              setPage(1);
              GetPayments_function().then(() => null);
            }}
          >
            بروزرسانی
          </button>
        </div>
      </div>

      {GetPayments_error ? (
        <div className={styles.empty}>بارگذاری سفارشات ناموفق بود.</div>
      ) : null}

      {GetPayments_loading && !GetPayments_data ? (
        <div className={styles.empty}>در حال بارگذاری…</div>
      ) : null}

      {GetPayments_data ? (
        <MyListOrder
          data={GetPayments_data.result.docs}
          pages={GetPayments_data.result.totalPages}
          totalDocs={GetPayments_data.result.totalDocs}
          GetPayments_function={GetPayments_function}
          set_search_text={set_search_text}
          search_text={search_text}
          _status={_status}
          set_status={set_status}
          set_start_date={set_start_date}
          start_date={start_date}
          set_end_date={set_end_date}
          end_date={end_date}
          selectedDayRange={selectedDayRange}
          setSelectedDayRange={setSelectedDayRange}
          setPage={setPage}
          page={page}
        />
      ) : null}
    </div>
  );
};

export { GetOrders };
